"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const fluxible_router_1 = require("fluxible-router");
class Nav extends React.Component {
    constructor(props) {
        // props.selected = props.selected || null;
        // props.links = props.links || {};
        super(props);
    }
    render() {
        const selected = this.props.currentRoute;
        const links = [];
        for (let i in this.props.links) {
            if (this.props.links[i].isInMenu) {
                links.push(this.props.links[i]);
            }
        }
        const linkHTML = Object
            .keys(links)
            .filter((name) => links[name].page !== 'resume' || this.props.isResumeVisible)
            .map((name) => {
            //todo: refactor
            let className = '';
            const link = links[name];
            if (selected && selected.name === link.page) {
                className = 'active';
            }
            return (React.createElement("li", { className: className, key: link.path },
                React.createElement(fluxible_router_1.NavLink, { className: "pt-trigger", routeName: link.page, activeStyle: { backgroundColor: '#eee' } }, capitalize(link.page))));
        });
        const className = classNames('site-nav', { 'mobile-menu-hide': !this.props.isOpenMenu });
        return (React.createElement("div", { className: className },
            React.createElement("ul", { className: 'site-main-menu' }, linkHTML)));
    }
}
class NavProps {
}
class Route {
}
const capitalize = (s) => {
    if (typeof s !== 'string') {
        return '';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
};
exports.default = Nav;
